<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zGWigd/tc-custom/9781642796889.jpg?1697136358388" alt="This image is the cover for the book Uncomfortable Glass Slippers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Uncomfortable Glass Slippers
      </h1>
      <p class="bookDescription body article font2">
        <b><i>The Uncomfortable Glass Slippers</i> sees a reluctant Sabrina Summers and her friends returning to the strange land of Dralfynia after Witchy Wu follows them to their high school.</b><p> In the sequel to <i>The Uncooperative Flying Carpet, The Uncomfortable Glass Slippers</i> shows Sabrina Summers as Prince Charming, her brother, Rory, is Baby Bear, and her friends, Persis and Olive, are Sleeping Beauty and Goldilocks. They learn that they need to find the magic glass slippers and take them and Ruggy, the uncooperative flying carpet, to the Island of Merthyr. Before that can happen, the friends encounter more goblins, a very smelly shoe museum, a terrifying were-dragon, and make unlikely friends with a pair of sisters desperate to marry any prince.</p><p> Once again, they use the skills that are unique to their fairytale characters and Sabrina’s courage and resourcefulness are pushed to the limit. To add to the drama, they discover that the real Cinderella has been imprisoned by the Beast with Eight Fingers in a case of seriously-mistaken identity, so they need to rescue her as well – all within three short days. By the end of <i>The Uncomfortable Glass Slippers</i>, Sabrina knows who she can trust, who has betrayed her, and what she needs to do next.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michele Clark McConnochie
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01a3db7c